import { api } from "../base";
import type { IFixAuditMessageTypeList } from "@pulse-ui/codegen-v2/generated_ts/fix_audit";

export type { IFixAuditMessageTypeList } from "@pulse-ui/codegen-v2/generated_ts/fix_audit";

export interface GetFixAuditMessageTypesParams {
  sender_comp_id: string;
  target_comp_id: string;
  session_id?: string;
  from_ms?: number;
  to_ms?: number;
}

const fixAuditMessageTypesEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getFixAuditMessageTypes: build.query<
      IFixAuditMessageTypeList,
      GetFixAuditMessageTypesParams
    >({
      query: (params) => ({
        url: "/api/trade/v1/fix-audit-message-types",
        params,
      }),
      providesTags: ["FixAuditMessageTypes"],
    }),
  }),
});

export const { useGetFixAuditMessageTypesQuery } = fixAuditMessageTypesEndpoints;
